export default {
  defaultObject () {
    return {
      id: undefined,
      name: '',
      phone: '',
      sms: '',
      url: '',
      email: '',
      description: '',
      category: '',
      courseId: null,
      image: null,
      point: { latitude: null, longitude: null }
    }
  }
}